import { useT } from "../i18n/I18nProvider";

export default function Legal({ type = "mentions" }) {
  const { t } = useT();
  const key = type === "mentions" ? "legal.mentions" : type === "privacy" ? "legal.privacy" : "legal.cgu";
  const data = t(key);

  return (
    <div className="max-w-3xl mx-auto px-4 py-16 md:py-24" data-testid={`legal-${type}`}>
      <h1 className="font-display text-4xl sm:text-5xl font-bold text-slate-900 tracking-tight mb-10">{data.title}</h1>
      <div className="space-y-8">
        {data.body.map(([heading, text], i) => (
          <section key={i}>
            <h2 className="font-display text-xl font-semibold text-slate-900 mb-2">{heading}</h2>
            <p className="text-slate-600 leading-relaxed">{text}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
